export default "__VITE_ASSET__BGnRdfjS__"